<template>
  <div>
    <b-modal
      id="modalInfo"
      v-model="showSuccessModal"
      modal-class="modalInfo"
      :title="$t('label_administration_notification_success_title')"
    >
      <div style="padding: 20px">{{ $t('label_administration_notification_success_description') }}</div>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-btn variant="primary" @click="closeSuccess()">
          {{ $t("Close") }}
        </b-btn>
      </div>
    </b-modal>
    <b-container>
      <b-row>
        <b-col>
          <b-button
            variant="primary"
            style="margin-top: 20px"
            @click="clearForms()"
          >
            {{ $t('label_administration_clear') }}
          </b-button>
          <form-wizard
            ref="wizard"
            color="#1e4380"
            shape="tab"
            :title="$t('label_administration_businessCreation')"
            subtitle=""
            @on-complete="processData()"
          >
            <tab-content
              :title="$t('label_administration_addBusiness')"
              icon="ti-briefcase"
              :before-change="validateBusinessErrors"
            >
              <create-business-tab
                ref="createBusinessTab"
              ></create-business-tab>
            </tab-content>
            <tab-content
              :title="$t('label_administration_selectTags')"
              icon="ti-tag"
              class="self-assesment"
              :before-change="createGroupTagRoles"
            >
              <tags-tab></tags-tab>
            </tab-content>
            <tab-content
              :title="$t('label_administration_RolesAndUsers')"
              icon="ti-user"
              :before-change="validateRolesAndUsersErrors"
            >
              <roles-and-users-tab ref="rolesAndUsers"></roles-and-users-tab>
            </tab-content>
            <tab-content :title="$t('label_administration_summary')" icon="ti-list-ol">
              <summary-tab></summary-tab>
            </tab-content>
            <template v-if="getIsSubmitting" slot="finish">Creating...</template>
          </form-wizard>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import CreateBusinessTab from "@/components/modules/administration/businessCreation/tabs/CreateBusinessTab";
import TagsTab from "@/components/modules/administration/businessCreation/tabs/TagsTab";
import RolesAndUsersTab from "@/components/modules/administration/businessCreation/tabs/RolesAndUsersTab";
import SummaryTab from "@/components/modules/administration/businessCreation/tabs/SummaryTab";

export default {
  name: "ConfigurationWizard",
  components: {
    RolesAndUsersTab,
    TagsTab,
    CreateBusinessTab,
    FormWizard,
    TabContent,
    SummaryTab
  },
  data() {
    return {
      showSuccessModal: false,
      storeName: "state",
      status: {
        createRole: false,
        createUser: false,
      },
      // eslint-disable-next-line camelcase
      accountRoleName: null,
      accountRoleId: null,
      business: null,
      refreshTags: 0,
      tagsData: null,
      businessId: null,
      accountRole: null,
      accountRoleTemplate: null,
      country: null,
      userAccountId: null,
      userAccount: null,
      allowedRolesFilter: null,
      refreshAccountRole: 0,
      preFillSnapshot: [],
      snapshotFilter: null,
      creationStatus: {
        businessTags: [],
        roles: [],
        roleTemplates: [],
        users: [],
        accountRoles: [],
      },
      createdIds: {},
      rolesAndUsers: [],
      defaultTags: [],
      submitDisable: false
    };
  },
  watch: {
    'getBusinessCreated': function (){
      console.log('ahaahahsdasd',this.getBusinessCreated)
      if(this.getBusinessCreated === 'ok'){
        this.showSuccessModal = true
        this.submitDisable = false
      }else if(this.getBusinessCreated==='error'){
        this.submitDisable = false
      }
    }
  },
  methods: {
    validateBusinessErrors: async function () {
      const ret =
        await this.$refs.createBusinessTab.$refs.businessForm.validForm();
      if (ret) {
        await this.$store.dispatch('setDefaultTags')
      }
      return ret;
    },
    closeSuccess() {
      this.clearForms();
    },
    async validateRolesAndUsersErrors() {
      let ret = this.$refs.rolesAndUsers.verifyValidity();

      await this.$store.dispatch('clearCreationStatus')
      return ret;
    },
    clearForms() {
      this.$store.dispatch("clearStore");
      this.$router.go();
    },
    processData: async function () {
      if(!this.submitDisable) {
        await this.$store.dispatch('submitForm')
      }
    },
     createGroupTagRoles: async function(){
      const ret = true
       await this.$store.dispatch('rebuildRolesFromGroupTag')
       await this.$store.dispatch('getAccountRolesForTags')
      return ret
    }
  },
  computed: {
    ...mapGetters([
      "getTagsToCreate",
      "getAllStoreInfo",
      "getRolesToCreate",
      "getShouldSelectTags",
      "getBusinessCreated",
      "getIsSubmitting"
    ]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
